import { Component, OnInit } from '@angular/core';
import { Filter } from 'src/app/user-management/_model/filter.model';
import { DataService } from 'src/app/dashboard/_services/data.service';
import { GlobalService } from 'src/app/_services/global.service';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { SubscriptionRequestsService } from '../_services/subscription-requests.service';
import { environment } from 'src/environments/environment';
import { ErrorMsgService } from 'src/app/shared/error-msg/error-msg.service';
import { AmplitudeService } from 'src/app/_services/amplitude.service';
import { ToasterMsgService } from 'src/app/shared/toaster-msg/toaster-msg.service';
import { AutoUnsubscribe } from 'src/app/shared/decorators/auto-unsubscribe.decorator';

declare var $: any;
@AutoUnsubscribe
@Component({
  selector: 'app-subscription-requests',
  templateUrl: './subscription-requests.component.html',
  styleUrls: ['./subscription-requests.component.scss']
})
export class SubscriptionRequestsComponent {
  currLang;
  testRequests = [];
  loading = false;
  allRequests = [];
  baseUrl = environment.img_url;
  from: number;
  to: number;
  total: number;
  nextPage: number;
  prevPage: number;
  currentPage: number;
  lastPage: number;
  toasterIconType: string = "";
  toasterMsg: string = ""
  showToasterFlag: boolean;
  showToasterIcon: boolean;
  destroy$ = new Subject<void>(); 
  schoolNotSubscribedToCommute: boolean = false;

  constructor(
    private dataService: DataService,
    private translate: TranslateService,
    private globalService: GlobalService,
    private subscribtionRequestsService: SubscriptionRequestsService,
    private errorMsgService: ErrorMsgService,
    private toasterService: ToasterMsgService,
    private amplitudesService: AmplitudeService
  ) {
    this.globalService.getLang().pipe(takeUntil(this.destroy$)).subscribe(lng => {
      //console.log('(c)subscription requests(f)getLang_(L)48' , lng);
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
  }

  ngOnInit(): void {
    $('.modal').modal('hide');
    $('body').removeClass('modal-open');
    $('.modal-backdrop').remove();
    this.currentPage = 1;
    this.getAllRequests();
  }

  ngOnDestroy(): void {
    this.errorMsgService.setReloadOnClose(false);
    this.errorMsgService.setMessage(null);
  }

  getAllRequests() {
    this.loading = true;
    this.subscribtionRequestsService.getAllSubscribtionRequests(true, 25, this.currentPage).pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      //console.log('(c)subscription requests(f)getAllRequests_(L)70' , res);
      this.schoolNotSubscribedToCommute = false;
      this.from = res.from;
      this.to = res.to;
      this.total = res.total;
      this.lastPage = res.last_page;
      if (this.total <= 25) {
        this.allRequests = [...res?.data];
      }
      else {
        this.allRequests = [...this.allRequests, ...res?.data];
      }
      this.loading = false;
    }, err => {
      this.errorHandler(err);
    })
  }

  approveRequest(requestId: number) {
  let approveRequestId = requestId;
  this.loading = true;
    this.subscribtionRequestsService.approveSubscribtionRequest(requestId).pipe(takeUntil(this.destroy$)).subscribe(res => {
      //console.log('(c)subscription requests(f)approveSubscribtionRequest_(L)91' , res);
      this.currentPage = 1;
      // this.getAllRequests();
      this.showToaster('approve');
      this.removeRequesstById(approveRequestId);
    }, err => {
      this.errorHandler(err);
    })
    this.amplitudesService.trackEvent('bus_request_approved', {})
  }
  declineRequest(requestId: number) {
    let declineRequestId = requestId;
    this.loading = true;
    this.subscribtionRequestsService.declineSubscribtionRequest(requestId).pipe(takeUntil(this.destroy$)).subscribe(res => {
      //console.log('(c)subscription requests(f)declineSubscribtionRequest_(L)105' , res);
      this.currentPage = 1;
      // this.getAllRequests();
      this.showToaster('decline');
      this.removeRequesstById(declineRequestId);
    }, err => {
      this.errorHandler(err);
    });
    this.amplitudesService.trackEvent('bus_request_declined', {})
  }

  nextBtnHandler() {
    if (this.currentPage < this.lastPage) {
      this.currentPage = this.currentPage + 1;
      this.getAllRequests();
    }
  }

  errorHandler(err: any) {
    if (err?.status == 403) {
      this.loading = false;
      this.schoolNotSubscribedToCommute = true;
    }
    else {
      this.errorMsgService.setReloadOnClose(true);
      this.errorMsgService.setMessage(err?.error?.message);
    }
  }

  showToaster(type: string) {
    switch (type) {
      case 'approve':
        this.toasterService.setToasterConfig({
          showToaster:true,
          showIcon:true,
          localizeMsg:true,
          iconType:'checkMark',
          msg:'buses.subscribtion-requests.approve-msg'
        })        
        break;
      case 'decline':
        this.toasterService.setToasterConfig({
          showToaster:true,
          showIcon:true,
          localizeMsg:true,
          iconType:'crossMark',
          msg:'buses.subscribtion-requests.decline-msg'
        })   
        break;
      default:
        break;
    }
    this.loading = false;
  }

  removeRequesstById(id: number): void {
    if(this.allRequests.length > 0 ){
      const index = this.allRequests.findIndex(request => request.id === id);
      if (index !== -1) {
        this.allRequests.splice(index, 1);
      }
    }
  }
}
